import { apiJWT } from "api/api-jwt";
import {
  CampanhaWhatsAppCompletedDataProps,
  CampanhaWhatsAppListProps
} from "components/campanha-whatsapp-components/utils";
import { User } from "contexts/types/application-context-types";

export class CampanhaWhatsAppEndpoints {
  static getCampanhasWhatsApp(user: User) {
    return async (currentPage: number) => {
      const { data } = await apiJWT.get<{
        data: CampanhaWhatsAppListProps[];
        count: number;
      }>("/campanhas-wpp/search", {
        params: {
          customer_id: user.userData.customerId,
          page_number: currentPage
        }
      });
      return data;
    };
  }

  static async postCampanhasWhatsApp(body: FormData) {
    const { data } = await apiJWT.post<CampanhaWhatsAppListProps>(
      "/campanhas-wpp",
      body
    );
    return data;
  }

  static async updateCampanhaWhatsApp(
    campanhaId: number,
    body: { wppSessionIds?: number[]; qtdEstimadaEnvioDia?: number }
  ) {
    const { data } = await apiJWT.put(`/campanhas-wpp/${campanhaId}`, body);
    return data;
  }

  static async getCampaignCompletedData(campanhaId: number) {
    const { data } = await apiJWT.get<CampanhaWhatsAppCompletedDataProps>(
      `/campanhas-wpp/${campanhaId}`
    );
    return data;
  }

  static async playCampanhaWhatsApp(campanhaId: number) {
    const { data } = await apiJWT.get<{ paused: boolean }>(
      `/campanhas-wpp/${campanhaId}/play`
    );
    return data;
  }

  static async pauseCampanhaWhatsApp(campanhaId: number) {
    const { data } = await apiJWT.get<{ paused: boolean }>(
      `/campanhas-wpp/${campanhaId}/pause`
    );
    return data;
  }

  static async deleteCampanhaWhatsApp(campanhaId: number) {
    const { data } = await apiJWT.delete(`/campanhas-wpp/${campanhaId}`);
    return data;
  }
}
